import PropTypes from 'prop-types';
import styles from './FJMobileFaceSwapSecond.module.less';
import FJIconButton from '../../../common/components/FJIconButton/FJIconButton';
import FJLocalStore from '../../../store/FJLocalStore';
import FJMobileFaceSwapPresetContainer from '../FJMobileFaceSwapPreset/FJMobileFaceSwapPresetContainer';
import FJFileUpload from '../../../common/components/FJFileUpload/FJFileUpload';
import { useRef, useEffect, useState } from 'react';

const FJMobileFaceSwapSecond = props => {
    const { active, onNextClick, onUploadOriginImage, originUploadImageInfo, simplePreview } = props;
    const imgBoxRef = useRef(null);
    const [imgStyle, setImgStyle] = useState({});
    useEffect(() => {
        if (imgBoxRef.current && originUploadImageInfo && active) {
            const imgRatio = originUploadImageInfo.width / originUploadImageInfo.height;
            const imgBoxRect = imgBoxRef.current.getBoundingClientRect();
            const imgBoxRatio = imgBoxRect.width / imgBoxRect.height;
            if (imgRatio > imgBoxRatio) {
                setImgStyle({ width: imgBoxRect.width, height: imgBoxRect.width / imgRatio });
            } else {
                setImgStyle({ height: imgBoxRect.height, width: imgBoxRect.height * imgRatio });
            }
        }
    }, [originUploadImageInfo, imgBoxRef, active]);
    return (
        <div className={styles.container} style={{ display: active ? 'block' : 'none' }}>
            <div className={styles.main_box}>
                <div className={styles.img_box} ref={imgBoxRef}>
                    <img className={styles.img} style={imgStyle} src={originUploadImageInfo.src} alt='' />
                </div>
                <div className={styles.main_footer}>
                    <div
                        className={styles.preview}
                        onClick={() => {
                            simplePreview(originUploadImageInfo);
                        }}
                    >
                        {FJLocalStore._('preview')}
                    </div>
                    <FJFileUpload className={styles.change} onUpload={onUploadOriginImage}>
                        {FJLocalStore._('change')}
                    </FJFileUpload>
                </div>
            </div>
            <FJMobileFaceSwapPresetContainer />
            <div className={styles.footer}>
                <FJIconButton
                    className={styles.next_btn}
                    type={'gradient'}
                    onClick={onNextClick}
                    text={FJLocalStore._('next')}
                    textClassName={styles.btn_text}
                />
                <div className={styles.mask} />
            </div>
        </div>
    );
};

FJMobileFaceSwapSecond.propTypes = {
    active: PropTypes.bool,
    onNextClick: PropTypes.func,
    onUploadOriginImage: PropTypes.func,
    simplePreview: PropTypes.func,
    originUploadImageInfo: PropTypes.object,
};
export default FJMobileFaceSwapSecond;
